// extracted by mini-css-extract-plugin
export default {"container":"UserChat_container__3D692","layer":"UserChat_layer__l4Ni6","button":"UserChat_button__Mt3HC","chatContainer":"UserChat_chatContainer__m4qgU"};